import React, { createContext, useContext } from 'react';

import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../prop-types/children';

const initialValue = {
  classes: {
    collapsibleSection: undefined,
    collapsibleSectionHeaderContent: undefined,
    collapsibleSectionContent: undefined,
    collapsibleSectionGrabberIcon: undefined,
    collapsibleSectionCaretIcon: undefined,
    form: undefined,
    sectionTitle: undefined,
    optionSection: undefined,
    billToRow: undefined,
    billToLabel: undefined,
    billToDropdown: undefined,
    readonlyRow: undefined,
    readonlyValueSection: undefined,
    headerPillsContainer: undefined,
    headerPill: undefined,
  },
  shouldInputsBeFullWidth: false,
};

export const OtherShippingOptionsStyleContext = createContext(initialValue);

export const useOtherShippingOptionsStyleContext = () => useContext(OtherShippingOptionsStyleContext);

const OtherShippingOptionsStyleContextProvider = ({ children, value = initialValue }) => {
  return <OtherShippingOptionsStyleContext.Provider value={value}>{children}</OtherShippingOptionsStyleContext.Provider>;
};

export default OtherShippingOptionsStyleContextProvider;

OtherShippingOptionsStyleContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  value: PropTypes.shape({
    classes: PropTypes.shape({
      collapsibleSectionHeaderContent: PropTypes.string,
      collapsibleSectionContent: PropTypes.string,
      form: PropTypes.string,
      sectionTitle: PropTypes.string,
      optionSection: PropTypes.string,
      billToRow: PropTypes.string,
      billToDropdown: PropTypes.string,
      readonlyRow: PropTypes.string,
      readonlyValueSection: PropTypes.string,
    }),
    shouldInputsBeFullWidth: PropTypes.bool,
  }),
};
